// GradeReveal.tsx - the inline two-axis grade (S22). After a decision commits, this replaces the felt
// dock's neutral confirmation: a verdict headline, Axis A (the play/hand), Axis B (the read/game) - each
// painted in the exact Chess.com move-class hexes (tokens.css --best/--exc/--inacc/--blun/...) - the coach
// callout (wrong-answer coaching fires here, red-bordered, only on the diverged street), and the
// <CoachDrawer> "See the full debrief" button.
//
// Ported 1:1 from the mockup grade markup (dg-verdict / dg-axisA / dg-axisB / dg-coach / dg-see). Colors
// come straight from CSS custom properties so the hexes are exact.
import { CoachDrawer } from './CoachDrawer';
import { classHeading } from './resolve';
import type { AxisGrade, ResolvedGrade } from './types';

/** One graded axis row: colored square badge (A/B), eyebrow, colored heading, coaching paragraph. */
function AxisRow({ axis }: { axis: AxisGrade }) {
  return (
    <div className="arow">
      <div className="mk" style={{ background: `var(--${axis.cls})` }}>
        {axis.badge}
      </div>
      <div>
        <div className="k">{axis.kicker}</div>
        <div className="v" style={{ color: `var(--${axis.cls})` }}>
          {classHeading(axis.cls, axis.label)}
        </div>
        <p>{axis.text}</p>
      </div>
    </div>
  );
}

export function GradeReveal({ grade }: { grade: ResolvedGrade }) {
  const { verdict, axisA, axisB, coach, debrief } = grade;
  return (
    <div className="graded">
      <div>
        <div className="kicker">Debrief</div>
        <div className="h2">How you saw it</div>
        <div className="lede">Graded on the read and the play, not on whether you won.</div>
      </div>

      <div className="verdict">
        <div className="cls">
          <span className="mk" style={{ background: `var(--${verdict.cls})` }}>
            {verdict.mark}
          </span>{' '}
          {verdict.label}
        </div>
        <div className="sub">{verdict.sub}</div>
      </div>

      <AxisRow axis={axisA} />
      <AxisRow axis={axisB} />

      <div className={'coach' + (coach.bad ? ' bad' : '')}>
        <b>{coach.lead}</b> {coach.text}
      </div>

      <CoachDrawer debrief={debrief} />
    </div>
  );
}
